import {
  PusherActionType,
  PusherReduxAction,
} from '../../../../../../../../redux/pusher/PusherActions';
import { scheduleActions } from '../../../actions';
import { put, select } from 'redux-saga/effects';
import { selectAircraftContractTimelineEntriesSaga } from '../../../selectors-saga';
import { getRouter } from '../../../../../../../../redux/selectors';
import { RouterState } from 'connected-react-router';

export function* handleAircraftContractEntryDelete(
  action: PusherReduxAction<PusherActionType.AIRCRAFT_CONTRACT_ENTRY_DELETED>,
) {
  const { location } = (yield select(getRouter)) as RouterState;
  if (!location.pathname.includes('crew-scheduling-v3')) {
    return;
  }
  const { payload } = action;

  try {
    const existedEntries = yield* selectAircraftContractTimelineEntriesSaga();
    const updatedEntries = existedEntries.filter(e => {
      return e.ID !== payload.ID;
    });

    yield put(scheduleActions.setState({ aircraftContractTimelineEntries: updatedEntries }));
  } finally {
    yield put(scheduleActions.reFetchAllEntries())
  }
}
